import graphql from 'babel-plugin-relay/macro';
import createMutation from '../../helpers/createMutation';

const mutation = graphql`
  mutation UserCreateMutation($input: User__CreateInput!) {
    userCreate(input: $input) {
      error
      token
      user {
        id
        dbId
        firstName
        lastName
        email
        paymentAccountStripeUid
      }
    }
  }
`;

const commit = input =>
  createMutation({
    mutation,

    variables: {
      input
    }
  });

export default { commit };
